import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Galiper_Title } from '../../../../../utils/ES/Modals/CorpModals';

const ModalCorpGaliper = () => {
  return (
    <>
      <ModalVideo
        id="corporate-galiper"
        dataText={Galiper_Title}
        videoSrc="https://player.vimeo.com/video/781987032?h=681348de48&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_GALIPER"
      />
    </>
  );
};

export default ModalCorpGaliper;
